export const AUTH_LOGIN = '/auth/oauth/v2/token'
export const AUTH_LOGOUT = '/auth/logout'
export const AUTH_FORGOT_PASSWORD = '/auth/forgot-password'
export const AUTH_SET_PASSWORD = '/auth/set-password'
export const REMOVE_DEVICE_ID = '/auth/remove-device'

export const USER_PROFILE = '/company/profile'
export const USER_GRID_SETTINGS = '/company/user/gridSettings/:gridName'

export const PATIENTS = '/company/patients'
export const PATIENT = '/company/patients/:id'
export const PATIENT_CALCULATE_RISK =
  '/company/patients/:patient/calculate-risk'
export const UPDATE_PATIENT_SPECIAL_FIELDS =
  '/company/patients/:patientUuid/special-fields'
export const PATIENT_GET_COUNT_ACTIVE_CARE_PLAN =
  '/workflow/carePlan/countActive/patient/:patientUuid'
export const PATIENT_REFERRAL_INFO_PATCH =
  '/company/patients/:patientUuid/referral-info'

// patient demographics
// personal info tab
export const PATIENT_DEMOGRAPHICS_PHONES =
  '/company/patients/:patientUuid/phones'
export const PATIENT_DEMOGRAPHICS_PHONE =
  '/company/patients/:patientUuid/phones/:phoneUuid'
export const PATIENT_DEMOGRAPHICS_EMAILS =
  '/company/patients/:patientUuid/emails'
export const PATIENT_DEMOGRAPHICS_EMAIL =
  '/company/patients/:patientUuid/emails/:emailUuid'
export const PATIENT_DEMOGRAPHICS_ADDRESSES =
  '/company/patients/:patientUuid/addresses'
export const PATIENT_DEMOGRAPHICS_ADDRESS =
  '/company/patients/:patientUuid/addresses/:addressUuid'
export const PATIENT_DEMOGRAPHICS_EMERGENCY_CONTACTS =
  '/company/patients/:patientUuid/emergency-contacts'
export const PATIENT_DEMOGRAPHICS_EMERGENCY_CONTACT =
  '/company/patients/:patientUuid/emergency-contacts/:contactUuid'
export const SENS_SMS_APP_LINK =
  'auth/patient/:patientUuid/send-app-link/:employeeUuid'
export const PATCH_PATIENT_DEMOGRAPHICS_COMPANY_DIVISION =
  '/company/patients/:patientUuid/company-division'
export const PATIENT_DEMOGRAPHICS_GET_FACESHEET_REPORT =
  '/company/patient/:patientUuid/facesheet'
export const PATIENT_DEMOGRAPHICS_GET_FACESHEET_REPORT_BATCH =
  '/company/facesheet/export-batch'

// medical tab
export const PATIENT_DEMOGRAPHICS_PATIENT_TEAM =
  '/company/patients/:patientUuid/medical-teams'
export const PATIENT_DEMOGRAPHICS_PATIENT_TEAM_MEMBER =
  '/company/patients/:patientUuid/medical-teams/:specialistUuid'
export const PATIENT_DEMOGRAPHICS_PHARMACIES =
  '/company/patients/:patientUuid/pharmacies'
export const PATIENT_DEMOGRAPHICS_PHARMACY =
  '/company/patients/:patientUuid/pharmacies/:pharmacyUuid'
export const PATIENT_DEMOGRAPHICS_ALLERGIES =
  '/company/patients/:patientUuid/allergies'
export const PATIENT_DEMOGRAPHICS_EVENTS =
  '/company/patients/:patientUuid/events'
export const PATIENT_DEMOGRAPHICS_EVENT =
  '/company/patients/:patientUuid/events/:eventUuid'
export const SET_PATIENT_HEIGHT_POST = '/company/patient/:patientUuid/setHeight'

// assigned caregivers tab
export const GET_ASSIGNED_CAREGIVERS =
  '/company/careGiverPatient/patient/:patientUuid'
export const POST_PATCH_ASSIGNED_CAREGIVER = '/company/careGiverPatient'
export const DELETE_ASSIGNED_CAREGIVER =
  '/company/careGiverPatient/careGiver/:caregiverUuid/patient/:patientUuid'
export const CAREGIVER_POST_ADD_ASSIGNED_FACILITY =
  '/company/careGiver/batchFacility/assign/:caregiverUuid'
export const CAREGIVER_POST_DELETE_ASSIGNED_FACILITY =
  '/company/careGiver/batchFacility/remove/:caregiverUuid'

export const PATIENT_DISEASES = '/company/disease/patient/:uuid'
export const ASSIGN_DISEASE = '/company/disease/assign'
export const UPDATE_DISEASE = '/company/disease/update'
export const DELETE_DISEASE = 'company/patient/:uuid/disease/:diseaseUuid'
export const EXTERNAL_REFERRAL =
  'company/patients/:patientUuid/externalReferral'

export const REFERRAL_SERVICE_PROVIDER = 'company/referralServiceProvider'
export const REFERRAL_SERVICE_PROVIDER_EDIT =
  'company/referralServiceProvider/:referralServiceProviderUuid'
export const EXTERNAL_REFERRAL_ATTACHMENTS_UPLOAD =
  'company/patientExternalReferral/:patientExternalReferralUuid/attachment'
export const EXTERNAL_REFERRAL_UPDATE =
  'company/patients/:patientUuid/externalReferral/:patientExternalReferralUuid'
export const EXTERNAL_REFERRAL_CREATE =
  'company/patients/:patientUuid/externalReferral'
export const EXTERNAL_REFERRAL_DELETE =
  'company/externalReferral/:patientExternalReferralUuid'
export const EXTERNAL_REFERRAL_PDF_DOWNLOAD =
  'company/patientExternalReferral/:patientExternalReferralUuid/pdf'

export const EXTERNAL_REFERRAL_ATTACHMENTS_DELETE =
  'company/patientExternalReferral/:patientExternalReferralUuid/attachment/:attachmentUuid'

export const FOLLOW_UP_CALL = 'company/patients/:uuid/followUpCall'
export const DELETE_FOLLOW_UP_CALL = 'company/patient/:uuid/followUpCall'
export const UNLOCK_PATIENT = 'auth/patient/:uuid/unlock'
export const PATIENT_MEDICAL_DEVICES =
  '/company/medicalDevice/patient/:patientUuid'
export const CREATE_MEDICAL_DEVICE = '/company/medicalDevice/assign'
export const DELETE_MEDICAL_DEVICE = '/company/medicalDevice/:uuid'
export const EDIT_MEDICAL_DEVICE = '/company/medicalDevice/:uuid/update'
export const GET_MEDICAL_DEVICE_TYPES = '/company/medicalDeviceType'
export const GET_ICD = '/company/icd10'
export const PATIENT_DIAGNOSIS = '/company/patient/:uuid/diagnosis'
export const ASSIGN_DIAGNOSIS = '/company/diagnosis'
export const UPDATE_DIAGNOSIS = '/company/diagnosis/:uuid'
export const DELETE_DIAGNOSIS = 'company/diagnosis/:diagnosisUuid'
export const UPDATE_DIAGNOSIS_ORDER = '/company/diagnosisOrder'

// patient referrals
export const PATIENT_REFERRALS = 'company/patient/:uuid/referral'

// patient insurance
export const PATIENT_DEMOGRAPHICS_GET_INSURANSES =
  '/company/patient/:patientUuid/insurance'
export const PATIENT_DEMOGRAPHICS_POST_INSURANSE = '/company/insurance'
export const PATIENT_DEMOGRAPHICS_PATCH_DELETE_INSURANSE =
  '/company/insurance/:insuranseUuid'
export const PATIENT_DEMOGRAPHICS_INSURANSE_ORDER = '/company/insuranceOrder'

export const GET_PATIENT_ENROLLMENT =
  '/company/patients/:patientUuid/enrolled-programs'
export const POST_PATIENT_ENROLLMENT =
  '/company/patients/:patientUuid/enrolled-programs/start'
export const PATCH_PATIENT_ENROLLMENT =
  '/company/patients/:patientUuid/enrolled-programs'
export const POST_PATIENT_ENROLLMENT_DISCHARGE =
  '/company/patients/:patientUuid/enrolled-programs/discharge'
export const PATCH_PATIENT_RPM_BILLABLE =
  '/company/patients/:patientUuid/rpm-billable'

export const POST_PATIENT_PROGRAM = '/company/enrolled-sub-programs'
export const PATCH_PATIENT_PROGRAM =
  '/company/enrolled-sub-programs/:enrolledSubProgramUuid'
export const POST_PATIENT_PROGRAM_DISCHARGE =
  '/company/enrolled-sub-programs/:enrolledSubProgramUuid/discharge'
export const GET_PATIENT_PROGRAM_CONSENT_DOCUMENT =
  '/company/enrolled-sub-programs/:enrolledSubProgramUuid/consent-document'
export const DELETE_PATIENT_PROGRAM_CONSENT_DOCUMENT =
  '/company/enrolled-sub-programs/:enrolledSubProgramUuid/consent-document'

export const PATIENT_PROGRAM_ROLLBACK_POST =
  '/company/enrolled-programs/:enrolledProgramUuid/rollback'
export const PATIENT_SUB_PROGRAM_ROLLBACK_POST =
  '/company/enrolled-sub-programs/:enrolledProgramUuid/rollback'

export const PATIENT_ENROLLED_PROGRAMS_START =
  '/company/patients/:id/enrolled-programs/start'
export const PATIENT_ENROLLED_PROGRAMS_HOLD =
  '/company/patients/:id/enrolled-programs/hold'
export const PATIENT_ENROLLED_PROGRAMS_RESUME =
  '/company/patients/:id/enrolled-programs/resume'

export const PATIENT_ENROLLED_PROGRAM =
  '/company/patients/:id/enrolled-programs/active'
export const PATIENT_ENROLLED_PROGRAM_VALIDATE_RPM =
  '/company/patients/:patientUuid/enrolled-programs/validate-rpm'
export const PATIENT_ENROLLED_PROGRAM_VALIDATE_RTM =
  '/company/patients/:patientUuid/enrolled-programs/validate-rtm'
export const PATIENT_ENROLLED_PROGRAM_VALIDATE_COCM =
  '/company/patients/:patientUuid/enrolled-programs/validate-cocm'

export const PATIENT_ENROLLED_PROGRAM_HOLD =
  '/company/patients/:patientUuid/enrolled-programs/hold'
export const PATIENT_ENROLLED_PROGRAM_RESUME =
  '/company/patients/:patientUuid/enrolled-programs/resume'
export const PATIENT_ENROLLED_PROGRAM_ON_HOLD_HISTORY =
  '/company/patients/:patientUuid/hold-history'
export const PATIENT_ENROLLED_PROGRAM_RPM_BILLABLE_HISTORY =
  '/company/patients/:patientUuid/rpm-billable-history'

export const PATIENT_COURSES = '/workflow/patients/:id/courses'
export const PATIENT_COURSES_SET_ACTIVE =
  '/workflow/patients/:id/courses/:course/set-active'
export const PATIENT_COURSES_PATCH =
  '/workflow/patients/:patientUuid/courses/:uuid'
export const RESET_PATIENT_COURSE =
  '/workflow/patients/:patientUuid/courses/:uuid/reset'

export const PATIENT_ACTIVITY_LOG = '/workflow/patient/:patientUuid/activityLog'
export const CREATE_PATIENT_ACTIVITY = '/workflow/activityLog'
export const ACTIVITY_LOG_AI_HELPER = '/workflow/activityLog/ai-helper'
export const GET_PATIENT_ACTIVITY_LOG_EXPORT =
  '/workflow/patient/:patientUuid/activityLog/export'
export const GET_PATIENT_ACTIVITY_LOG_PDF_EXPORT =
  '/workflow/patient/:patientUuid/activityLog/export-pdf'

export const PATIENT_ACTIVITY = '/workflow/activityLog/:activityLogUuid'

export const PATIENT_WALLET = '/gamification/patient/:patientUuid/vault'
export const PATIENT_WALLET_HISTORY =
  '/gamification/patient/:patientUuid/vault-history'

export const PATIENT_REWARD_HISTORY =
  '/gamification/patient/:patientUuid/patient-rewards'
export const PATIENT_COMPLIANCE =
  '/gamification/web/patient/:patientUuid/compliance'

export const PATIENT_CHAT_TOTAL_MESSAGES = '/chat/patient/:uuid/total-messages'
export const PATIENT_READING_ANSWERS =
  '/workflow/patient/:uuid/chart-reading-answers'

export const GAMIFICATION_MODULES = 'gamification/modules'

// Clinical Pathway routes
export const CLINICAL_PATHWAYS = '/workflow/clinical-pathway'
export const CLINICAL_PATHWAYS_CHECK_ACTIVE =
  '/workflow/clinical-pathway/:uuid/is-has-active/:patientUuid'
export const CLINICAL_PATHWAYS_ASSIGNED =
  '/workflow/patient/:uuid/clinical-pathway/assigned'
export const CLINICAL_PATHWAYS_REPORT_EXPORT =
  '/workflow/patient/:patientUuid/check-in-answers/export'

export const CLINICAL_PATHWAY_PATIENT_LIST =
  '/workflow/clinical-pathway-patient'
export const CLINICAL_PATHWAY_PATIENT =
  '/workflow/clinical-pathway-patient/:uuid'

export const CLINICAL_PATHWAY_PATIENT_CHECK_IN_LIST =
  '/workflow/clinical-pathway-patient/:uuid/check-in'
export const CLINICAL_PATHWAY_PATIENT_CHECK_IN =
  '/workflow/clinical-pathway-patient/:uuid/check-in/:checkInUUID'

export const CLINICAL_PATHWAY_PATIENT_ANSWER_LIST =
  '/workflow/patient/:patientUuid/check-in-answers'
export const CLINICAL_PATHWAY_PATIENT_ANSWER_DELETE =
  '/workflow/patient-answer/:uuid'
export const CLINICAL_PATHWAY_PATIENT_COPY =
  '/workflow/clinical-pathway-patient/:clinicalPathwayPatientUuid/copy'

export const GET_CLINICAL_PATHWAY_QUESTIONS =
  '/workflow/clinical-pathway/:clinicalPathwayUuid/questions'
export const GET_CHECK_IN_LIST_QUESTIONS =
  '/workflow/check-in/:checkInUuid/questions'
export const POST_PATIENT_CHECK_IN =
  '/workflow/clinical-pathway-patient/:clinicalPathwayPatientUuid/check-in'
export const PATCH_PATIENT_CHECK_IN = '/workflow/check-in/:patientCheckInUuid'
export const CLINICAL_PATHWAY_PATIENT_ALERT_STATUS_DECISION =
  '/workflow/patient/:patientUuid/clinical-pathway-patient/:clinicalPathwayPatientUuid/alert-status-decision'

// temporary for dev reason
export const CLINICAL_PATHWAY_PATIENT_CREATE_CHECK_IN =
  '/workflow/clinical-pathway-patient/:uuid/create-check-in'

export const COURSES = '/workflow/courses'

export const COMPANY_EMPLOYEES = '/company/employees'
export const COMPANY_DISEASES = '/company/diseases'
export const COMPANY_DISEASES_UPDATE = '/company/diseases/:diseaseUuid'
export const COMPANY_STRUCTURE = '/company/company-division/tree'
export const COMPANY_CASE_MANAGERS = '/company/case-managers'

export const ALERTS = '/workflow/alerts'
export const ALERT = '/workflow/alerts/:alertUuid'
export const ALERT_TYPES = '/workflow/alert-types'
export const ALERT_HISTORY = '/workflow/alerts/:id/histories'
export const NEW_ALERTS_COUNT = '/workflow/alerts/new-alerts-count'
export const ALERTS_PRIORITY_COUNT = '/workflow/alerts/alertPriorityCount'
export const POST_ALERTS_BATCH_CLOSE = '/workflow/alerts/batchClose'
export const CLOSE_RELATED_ALERTS = '/workflow/alerts/batchCloseFromModal'
export const GET_PROTOCOL_LIST = '/workflow/alert-notes'
export const GET_NARRATIVE_QUESTION_LIST =
  '/workflow/alert-notes/:alertNoteUuid'
export const GET_PATIENT_OPEN_ALERTS =
  '/workflow/patient/:patientUuid/open-alerts'
export const ALERT_GET_EXPORT_LIST = '/workflow/alerts/export'
export const ALERT_DASHBOARD = '/workflow/alertDashboard'
export const ALERT_DASHBOARD_BY_CASE_MANAGER =
  '/workflow/alertDashboard/totalAlertsByCaseManager'
export const ALERT_DASHBOARD_BY_FACILITY =
  '/workflow/alertDashboard/totalAlertsByFacility'

export const CHATS = '/chat/chats'
export const CHAT = '/chat/chats/:uuid'
export const CHAT_MESSAGES = '/chat/chats/:uuid/messages'
export const CHAT_MESSAGE = '/chat/chats/:chat_uuid/messages/:message_uuid'
export const CHAT_MESSAGE_ACKNOWLEDGEMENT =
  '/chat/chats/:chat_uuid/messages/:message_uuid/set-acknowledged'
export const CHATS_UNREAD_COUNTER = '/chat/chats/count-not-acknowledged'
export const GET_CHAT_IMAGE = '/chat/chats/image/:imageMessageUuid'
export const POST_CHAT_IMAGE = '/chat/chats/:chatUuid/image'
export const COMMUNICATIONS = '/chat/patient/:patientUuid/communications'
export const COMMUNICATIONS_EXPORT =
  '/chat/patient/:patientUuid/communications/export'

// gamification routes
export const GAMIFICATION_ACHIEVEMENTS = '/gamification/web/achievements'
export const GAMIFICATION_ACHIEVEMENT =
  '/gamification/web/achievements/:achievementUuid'
export const GAMIFICATION_TASKS = '/gamification/tasks'
export const GAMIFICATION_TASK = '/gamification/tasks/:taskUuid'
export const GAMIFICATION_SHOP_ITEMS = '/gamification/web/shopItems'
export const GAMIFICATION_SHOP_ITEM =
  '/gamification/web/shopItems/:shopItemUuid'
export const GAMIFICATION_REDEMPTION_LIST = '/gamification/web/externalItems'
export const GAMIFICATION_REDEMPTION_ITEM_UPDATE =
  '/gamification/web/redeemExternalOrder/:orderUuid'
export const GAMIFICATION_REDEMPTION_ITEM_HISTORY =
  '/gamification/web/redeemHistory/externalOrder/:orderUuid'
export const PATIENT_GAMIFICATION_ACTIVITIES =
  '/gamification/web/patient/:uuid/activity'
export const GAMIFICATION_ACHIEVEMENTS_LIST = '/gamification/web/achievements'
export const GET_REDEMPTION_BADGE_COUNT =
  '/gamification/web/externalItems/count'
export const EXPORT_REDEMPTION_GRID = '/gamification/web/externalItems/export'

export const PUBLIC_ROUTES = [
  AUTH_LOGIN,
  AUTH_LOGOUT,
  AUTH_SET_PASSWORD,
  AUTH_FORGOT_PASSWORD
]

// licenses routes
export const LICENSES_LIST = '/company/admin/licenses'
export const COMPANY_LICENSES = '/company/admin/license/company/:companyUuid'
export const LICENSES_ASSIGN = '/company/admin/licenses-assign'

// measurements
export const MEASUREMENT = '/workflow/measurement'
export const MEASUREMENT_DASHBOARD = '/workflow/measurement-dashboard'
export const MEASUREMENT_PATIENT_GET_POST = '/workflow/measurement-patient'
export const MEASUREMENT_PATIENT = '/workflow/measurement-patient/:uuid'
export const MEASUREMENT_PATIENT_CREATE_READING =
  '/workflow/measurement-patient/:uuid/create-reading'
export const MEASUREMENT_PATIENT_READING_ANSWERS =
  '/workflow/patient/:patientUuid/reading-answers'
export const MEASUREMENT_PATIENT_READING =
  '/workflow/measurement-patient/:measurementPatientUuid/reading'
export const MEASUREMENT_PATIENT_READING_ANSWER =
  '/workflow/measurement-patient-answer/:answerUuid'
export const MEASUREMENT_READING = '/workflow/reading/:readingUuid'
export const MEASUREMENT_PATIENT_READING_ANSWER_POST =
  '/workflow/reading/:readingUuid/measurement-patient-answer'
export const MEASUREMENT_PATIENT_READING_ANSWER_NO_DATA_POST =
  '/workflow/measurement-patient-answer'
export const MEASUREMENT_PATIENT_ASSIGNED =
  '/workflow/patient/:patientUuid/measurement/assigned'
export const MEASUREMENT_PATIENT_EXPORT_READING_REPORT =
  '/workflow/patient/:patientUuid/reading-answers/export'
export const MEASUREMENT_PATIENT_GET_VITAL_GRAPH =
  '/workflow/measurement/:patientUuid/vital-graph'
export const MEASUREMENT_PATIENT_COPY =
  '/workflow/measurement-patient/:measurementPatientUuid/copy'
export const MEASUREMENT_ALERT_STATUS_DECISION =
  '/workflow/patient/:patientUuid/measurement/:measurementUuid/alert-status-decision'
export const MEASUREMENT_PATIENT_ALERT_STATUS_DECISION =
  '/workflow/patient/:patientUuid/measurement-patient/:measurementPatientUuid/alert-status-decision'
export const MEASUREMENT_PATIENT_SYNC_DEVICE =
  '/workflow/integration/reSyncReadings/patient/:patientUuid'
export const MEASUREMENT_PATIENT_LAST_ANSWERS =
  '/workflow/measurement/patient-last-answers/:patientUuid '
export const MEASUREMENT_PATIENT_PATIENT_TREND =
  '/workflow/measurement/patient-trend/:patientUuid'

// medications
export const MEDICATION_PATIENT_GET = '/workflow/medication-patient/:uuid'
export const MEDICATION_PATIENT_POST = '/workflow/medication-patient'
export const MEDICATION_PATIENT_LIST_GET = '/workflow/medication-patient'
export const MEDICATION_PATIENT_CREATE_INTAKE =
  '/workflow/medication-patient/:uuid/create-intake'
export const MEDICATION_LIST_ASSIGNED =
  '/workflow/patient/:patientUuid/medication/assigned'

export const INTAKE_PATIENT_GET =
  '/workflow/patient/:patientUuid/intake-answers'
export const INTAKE_PATIENT_POST = '/workflow/medication-patient-answer'
export const INTAKE_PATIENT_PATCH_DELETE =
  '/workflow/medication-patient-answer/:uuid'
export const INTAKE_PATIENT_WITH_UUID_POST =
  '/workflow/intake/:uuid/medication-patient-answer'

export const MEDICATION_GET = '/workflow/medication'
export const MEDICATION_RULE_GET = '/workflow/medication-template-rule'
export const ORDERING_GET = '/company/patients/:patientUuid/medical-teams'
export const PHARMACY_GET = '/company/patients/:patientUuid/pharmacies'

export const MEDICATION_DASHBOARD_GET = '/workflow/medication-patient'
export const MEDICATION_DOSAGES_TYPES =
  '/workflow/medication/distinct-dosage-type'

export const MEDICATION_TOTAL_COMPLIANCE =
  '/workflow/medication/total-compliance'

export const EXPORT_REPORT_PATIENT_INTAKES =
  '/workflow/patient/:patientUuid/intake-answers/export'

export const MEDICATION_PATIENT_COPY =
  '/workflow/medication-patient/:medicationPatientUuid/copy'

export const MEDICATION_ALERT_STATUS_DECISION =
  '/workflow/patient/:patientUuid/medication/:medicationUuid/alert-status-decision'
export const MEDICATION_PATIENT_ALERT_STATUS_DECISION =
  '/workflow/patient/:patientUuid/medication-patient/:medicationPatientUuid/alert-status-decision'

// care plan
export const CARE_PLAN_GET_RESPONSIBLE_LIST =
  '/workflow/patient/:patientUuid/responsible-by-goal'

export const GOAL_LIST_GET = '/workflow/goal'
export const GOAL_CATEGORY_LIST_GET = '/workflow/goal-category'
export const PATIENT_GOALS = '/workflow/patient/:patientUuid/patient-goal'
export const COMPANY_GOALS = '/workflow/patients/goals'
export const PATIENT_GOAL_CUSTOM_POST =
  '/workflow/patient/:patientUuid/patient-goal/custom'
export const PATIENT_GOAL_GET_PATCH_DELETE = '/workflow/patient-goal/:uuid'

export const INTERVENTION_LIST_GET = '/workflow/intervention'
export const INTERVENTION_GET = '/workflow/intervention/:uuid'
export const INTERVENTION_TYPE_LIST_GET = '/workflow/intervention-category'
export const PATIENT_INTERVENTION_LIST_GET =
  '/workflow/patient-goal/:patientGoalUuid/patient-intervention'
export const PATIENT_INTERVENTION_POST =
  '/workflow/patient-goal/:patientGoalUuid/patient-intervention'
export const PATIENT_INTERVENTION_LIST_GET_BY_PATIENT =
  '/workflow/patient/:patientUuid/patient-intervention'
export const PATIENT_INTERVENTION_GET_PATCH_DELETE =
  '/workflow/patient-intervention/:uuid'
export const CARE_PLAN_REVIEW_POST = '/workflow/carePlanReview'
export const CARE_PLAN_REVIEW_GET = '/workflow/patient/:uuid/carePlanReview'
export const CARE_PLAN_REVIEW_EXPORT_PDF_GET =
  '/workflow/carePlanReview/:uuid/pdf'
export const CHART_REVIEW_EXPORT_PDF_GET =
  '/workflow/chart-review/:chartReviewUuid/pdf'
export const EXTERNAL_REFERRAL_PDF =
  '/company/patientExternalReferral/:patientExternalReferralUuid/pdf'
export const DIAGNOSTIC_ORDER_PDF =
  '/workflow/patient/diagnostic-order/:patientDiagnosticOrderUuid/pdf'
export const DME_ORDER_PDF =
  '/company/patient/durable-medical-equipment-order/:patientDurableMedicalEquipmentOrderUuid/pdf'
export const PRESCRIPTION_PDF =
  '/workflow/patient/prescription/:patientPrescriptionUuid/pdf'
export const VISIT_PDF = '/workflow/soap/visit/:soapVisitUuid/pdf'

export const CARE_PLAN_CHANGE_LOG_GET =
  '/workflow/patient/:uuid/carePlanChangeLog'
export const CARE_PLAN_REVIEW_DELETE = '/workflow/carePlanReview/:uuid'

export const CARE_PLAN_REVIEW_DATE_PATCH =
  '/company/patient/:patientUuid/nextCarePlanReviewDate'
// activity log timer
export const START_ACTIVITY_LOG = '/workflow/startTimer'
export const STOP_ACTIVITY_LOG = '/workflow/stopTimer/:timerUuid'
export const DELETE_TIMER = '/workflow/deleteTimer/:timerUuid'
export const PATIENT_LIST = '/company/patients'
export const ACTIVE_TIMERS = '/workflow/abandonedTimers'

// activity log dashboard
export const CCM_DASHBOARD = '/workflow/activityLog/ccmDashboard'
export const EXPORT_CCM_DASHBOARD_GRID =
  '/workflow/activityLog/exportCcmDashboardSearch'
export const CCM_DASHBOARD_GET_SUMMARY = '/workflow/activityLog/ccmPivot'

export const RPM_DASHBOARD = '/workflow/activityLog/rpmDashboard'
export const EXPORT_RPM_DASHBOARD_GRID =
  '/workflow/activityLog/exportRpmDashboardSearch'

// billing
export const GET_BILLING_ACTIVITY_LOG = '/workflow/billing/activityLog'
export const START_BILLING = '/workflow/billing/start'

export const GET_BILLING_BATCH_LIST = '/workflow/billing/batch'
export const GET_BILLING_INVOICE = '/workflow/billing/invoice/:uuid'

export const GET_BILLING_INVOICE_DETAILS =
  '/workflow/billing/invoiceDetail/:uuid'
export const UNBILL_INVOICE = '/workflow/billing/unbillInvoice/:uuid'

export const PATIENT_BILLING_STATISTICS =
  '/workflow/billing/boxes/patient/:uuid'

// broadcast
export const GET_BROADCAST_MESSAGE_VALUES = '/chat/broadcasting-message/:uuid'
export const GET_BROADCAST_MESSAGE_LIST = '/chat/broadcasting-message'

export const GET_BROADCAST_VALUES = '/chat/broadcasting/:uuid'
export const GET_BROADCAST_LIST = '/chat/broadcasting'

export const GET_BROADCAST_PATIENT = '/chat/broadcasting/patients'
export const GET_BROADCAST_PATIENT_WITH_UUID =
  '/chat/broadcasting/:uuid/patients'

export const EXPORT_BATCH_XLS = '/workflow/billing/exportInvoiceXLS/:uuid'
export const EXPORT_BATCH_PDF = '/workflow/billing/exportInvoicePDF/:uuid'

// admin
export const COMPANIES = 'company/admin/company'
export const UPDATE_COMPANY = 'company/admin/company/:uuid'

export const GET_COMPANY = 'company/admin/company/:companyUuid'
export const COMPANY_USERS = 'company/employees/company/:companyUuid'

export const CREATE_USER = 'company/employees'
export const GET_COMPANY_DIVISION = 'company/company-divisions'
export const GET_COMPANY_DIVISION_BY_COMPANY = 'company/company-division/tree'
export const GET_COMPANY_LANGUAGES = 'company/admin/language/company/:uuid'

export const UPDATE_USER = 'company/employees/:uuid'
export const USER_ROLES = 'company/role/company/:uuid'

export const GET_ADMINS_COUNT = 'auth/admin/company/Super Admin'
export const UNLOCK_USER = 'auth/user/:uuid/unlock'

export const GET_CM_BY_DIVISION = 'company/case-managers'
export const GET_COMPANY_GOAL_CATEGORY =
  'workflow/admin/company/:uuid/goalCategory'
export const GET_COMPANY_GOAL = 'workflow/admin/company/:uuid/goal'

// download
export const PATIENT_CONSENT_DATE = 'company/patient/:uuid/consentDate'

// case managers
export const UPDATE_CASE_MANAGER = 'company/case-managers/:uuid'
export const UPDATE_CASE_MANAGER_STATUS = 'company/case-manager/:uuid/status'
export const REASSIGN_CASE_MANAGER_PATIENTS =
  'company/caseManagerInactivateWithPatientReassignment'

// service history
export const GET_PRINTED_SERVICE_HISTORY_REPORT =
  '/workflow/activity-tracking-export'

// billing codes
export const GET_BILLING_PROGRAMS = '/workflow/billing/programs'
export const GET_BILLING_CODES = '/workflow/billing/code/patient/:uuid'
export const GET_ACTIVITY_BILLING_STATISTIC =
  '/workflow/activityLog/dashboardGraph'
export const POST_BILLING_CHECK_USAGE = '/workflow/billing/checkUsage'
export const GET_ADMIN_BILLING_PROGRAMS =
  '/workflow/admin/company/:companyUuid/billingPrograms'

// export dashboard
export const EXPORT_CCM_DASHBOARD = '/workflow/activityLog/ccmExport'
export const EXPORT_RPM_DASHBOARD = '/workflow/activityLog/rpmExport'

// telemedicine
export const SCHEDULED_ITEMS = '/chat/meeting'
export const SCHEDULED_ITEM = '/chat/meeting/:uuid'

export const BATCH_DELETE = 'chat/meeting/batchDelete'
export const BATCH_UPDATE_CHECK = '/chat/meeting/batchUpdateCheck'
export const BATCH_UPDATE = '/chat/meeting/batchUpdate'

export const JOIN_MEETING =
  '/chat/chimePortal/meeting/:uuid/attendee/:userUuid/join'
export const END_MEETING = '/chat/chimePortal/meeting/:uuid/end'
export const END_TELEMEDICINE_MEETING =
  '/chat/chimePortal/meeting/:meetingUuid/end'

export const GET_ATTENDEE_INFO =
  '/chat/chime/meeting/:awsMeetingId/attendee/:awsAttendeeId'

export const MEETING_SEND_SMS = '/chat/meeting/:meetingUuid/sms'
export const MEETING_SEND_EMAIL = '/chat/meeting/:meetingUuid/email'

export const GET_CLINICIAN_LIST = '/company/telehealth/users'
export const CLINICIANS = '/company/clinician'

export const UNLOCK_CLINICIAN = 'auth/user/:uuid/unlock'

export const UPDATE_CLINICIAN = '/company/clinician/:uuid'
export const CHECK_CLINICIAN_CALENDAR = '/company/clinician/:uuid/checkCalendar'
export const GET_WAITINGROOM_COUNT = '/chat/meetingCount'

export const OVERLAP_VALIDATION = '/chat/meeting/checkOverlap'

export const CALL_BACK_PATIENT =
  '/chat/chimePortal/meeting/:uuid/reinitializeCallingPatient'
export const GET_CALLEE_BY_PATIENT = '/chat/:uuid/callee'

export const GET_ACTIVE_MEETING =
  '/chat/urgent-care/call/:urgentCareCallUuid/details'

// user roles
export const USER_ROLES_LIST = '/auth/company-role'

// caregiver management
export const READING_ANSWER_REPORTED_BY =
  '/workflow/patient/:patientUuid/reading-answer-reported-by'
export const GET_EMPLOYEES_LIST =
  '/company/measurement-patient-answer/:patientMeasurementAnswerUuid'
export const GET_AVAILABLE_CAREGIVER_LIST =
  '/company/careGiver/patient/:patientUuid'
export const POST_CAREGIVER = '/company/careGiver'
export const GET_PATCH_DELETE_CAREGIVER = '/company/careGiver/:uuid'
export const GET_CAREGIVER_LIST = '/company/careGiver'

export const GET_POST_CAREGIVER_ADDRESS = '/company/careGiver/:uuid/address'
export const PATCH_CAREGIVER_ADDRESS =
  '/company/careGiver/:uuid/address/:addressUuid'
export const CAREGIVER_POST_SET_PIN = '/auth/caregiver/:careGiverUuid/set-pin'
export const CAREGIVER_POST_SEND_SMS =
  '/auth/caregiver/:careGiverUuid/send-pin-sms'
export const CAREGIVER_POST_GENERATE_PHONE =
  '/company/caregiver/:caregiverUuid/generatePhone'

export const EXPORT_CAREGIVER = '/company/careGiver/export'

export const GET_CAREGIVER_PATIENT_LIST =
  '/company/careGiverPatient/careGiver/:caregiverUuid'
export const POST_CAREGIVER_PATIENT_LIST =
  '/company/careGiverPatient/batch/assign/:caregiverUuid'
export const DELETE_CAREGIVER_PATIENT_LIST =
  '/company/careGiverPatient/batch/remove/:caregiverUuid'

export const GET_POST_CAREGIVER_GAMIFICATION_VAULT =
  '/gamification/careGiver/:caregiverUuid/vault'
export const GET_CAREGIVER_GAMIFICATION_HISTORY =
  '/gamification/web/caregiver/:caregiverUuid/activity'

// telemedicine
export const GET_TELEMEDICINE_DASHBOARD =
  '/workflow/activityLog/telemedicine/dashboard'
export const GET_TELEMEDICINE_BILLING_CODES =
  '/workflow/billing/telemedicine/programs'
export const EXPORT_TELEMEDICINE_DASHBOARD =
  '/workflow/activityLog/telemedicine/export'

// case manager census
export const GET_CASE_MANAGER_CENSUS_SUMMARY =
  '/report/caseManagerCensus/summaryReport'
export const EXPORT_CASE_MANAGER_CENSUS_SUMMARY_REPORT =
  '/report/caseManagerCensus/summaryReport/export'
export const GET_CASE_MANAGER_CENSUS_DETAILED =
  '/report/caseManagerCensus/detailedReport'
export const EXPORT_CASE_MANAGER_CENSUS_DETAILED_REPORT =
  '/report/caseManagerCensus/detailedReport/export'

// activity log report
export const GET_REPORT_ACTIVITY_LOG_LIST = '/workflow/activityLog'
export const EXPORT_REPORT_ACTIVITY_LOG = '/workflow/activityLog/export'
export const PATCH_ACTIVITY_LOG_CLINICIAN =
  '/workflow/activityLog/:activityLogUuid/clinician/:clinicianUuid'

// care plan report
export const CARE_PLAN_REPORT_GET_PATIENT_LIST =
  '/workflow/carePlan/patientList'
export const CARE_PLAN_REPORT_GET_EXPORT_LIST = '/workflow/carePlan/export/pdf'

// company dashboard
export const COMPANY_DASHBOARD_GET = '/company/dashboard/company'
export const COMPANY_DASHBOARD_GET_ACTIVITIES =
  '/workflow/dashboard/company/activities'
export const COMPANY_DASHBOARD_GET_ALERTS = '/workflow/dashboard/company/alerts'

// provider management
export const GET_PROVIDER_LIST = '/company/provider'
export const POST_PROVIDER = '/company/provider'
export const GET_PATCH_DELETE_PROVIDER = '/company/provider/:providerUuid'

// patient points report
export const GET_PATIENT_POINTS_REPORT = '/report/patientVault'
export const EXPORT_PATIENT_POINTS_REPORT = '/report/patientVault/export'

// patient events report
export const GET_PATIENT_EVENTS_REPORT = '/company/patients/events/report'
export const EXPORT_PATIENT_EVENTS_REPORT = '/company/patients/events/export'

// enrollment report
export const GET_ENROLLMENT_REPORT_LIST = '/company/enrolled-programs'
export const EXPORT_ENROLLMENT_REPORT = '/company/enrolled-programs/export'

// performance dashboard
export const GET_PERFORMANCE_DASHBOARD = '/workflow/dashboard/userPerformance'

// patient external documents
export const GET_PATCH_DELETE_PATIENT_EXTERNAL_DOCUMENT =
  '/company/patient/document/:attachmentUuid'
export const POST_PATIENT_EXTERNAL_DOCUMENT =
  '/company/patient/:patientUuid/document'
export const GET_PATIENT_EXTERNAL_DOCUMENTS =
  '/company/patient/:patientUuid/document'

// medical device list report
export const GET_MEDICAL_DEVICE_LIST_REPORT = '/report/medicalDevice/report'
export const EXPORT_MEDICAL_DEVICE_LIST_REPORT =
  '/report/medicalDevice/report/export'

// telemedicine log report
export const EXPORT_TELEMEDICINE_LOG_REPORT = '/chat/meeting/export'

// alert notes report
export const ALERT_NOTES_REPORT = '/report/alert-note/report'
export const ASSESSMENTS_REPORT = '/report/assessment/report'
export const MONTHLY_FACILITY_REPORT = '/report/monthly-facility/report'
export const MONTHLY_FACILITY_REPORT_EXPORT = '/report/monthly-facility/export'
export const ASSESSMENTS_EXPORT_REPORT = '/report/assessment/export/csv'

export const ASSESSMENTS_EXPORT_PDF_REPORT = '/report/assessment/export-batch'

export const ALERT_NOTES_REPORT_EXPORT = '/report/alert-note/export'

export const GET_PATIENT_ALERT_NOTE = '/company/patient/:uuid/patientAlertNote'
export const SAVE_PATIENT_ALERT_NOTE = '/company/patientAlertNote'
export const UPDATE_PATIENT_ALERT_NOTE = '/company/patientAlertNote/:uuid'
export const DELETE_PATIENT_ALERT_NOTE = '/company/patientAlertNote/:uuid'

// urgent care
export const GET_WAITING_ROOM_LIST = '/chat/urgent-care/queue'
export const UPDATE_WAITING_ROOM_ITEM = '/chat/urgent-care/call/:uuid'
export const GET_URGENT_CARE_USERS = '/chat/urgent-care/clinician'
export const GET_URGENT_CARE_USERS_BY_PATIENT =
  '/chat/urgent-care/clinician/patient/:uuid'
export const GET_URGENT_CARE_COUNTER = '/chat/urgent-care/count-new'
export const PING_AS_URGENT_CARE_CLINICIAN =
  '/chat/urgent-care/clinician/set-online'
export const URGENT_CARE_DECLINE_REASONS = '/chat/urgent-care/decline-reasons'
export const START_URGENT_CARE_CALL = '/chat/urgent-care/call/:uuid/connect'
export const END_URGENT_CARE_MEETING = '/chat/urgent-care/call/:uuid/end'
export const HOLD_MEETING = '/chat/urgent-care/call/:uuid/hold'
export const GET_URGENT_CARE_CLINICIANS_ON_DUTY =
  '/chat/urgent-care/clinicians-on-duty'
export const GET_URGENT_CARE_CLINICIANS_SET_OFFLINE =
  '/chat/urgent-care/clinician/set-offline'
export const SEND_SMS_INVITATION = '/chat/urgent-care/call/:uuid/inviteBySms'
export const SEND_EMAIL_INVITATION =
  '/chat/urgent-care/call/:uuid/inviteByEmail'
export const CALL_REASONS = '/chat/urgent-care/call-reasons'
export const CALL_REASONS_MUTATE = 'chat/urgent-care/call/:urgentCareCallUuid'

export const UPDATE_URGENT_CARE_STATUS_ROUTES = {
  new: '/chat/urgent-care/call/:uuid/renew',
  reviewed: '/chat/urgent-care/call/:uuid/review',
  completed: '/chat/urgent-care/call/:uuid/complete',
  declined: '/chat/urgent-care/call/:uuid/decline'
}

// billing detail
export const GET_BILLING_DETAIL = '/workflow/billing/details'
export const EXPORT_SUPERBILL = '/workflow/billing/details/export'

// telemedicine log report
export const GET_TELEMEDICINE_APPOINTMENT_LIST_REPORT = '/chat/meeting/report'
export const EXPORT_TELEMEDICINE_APPOINTMENT_LOG_REPORT = '/chat/meeting/export'

// urgent care report
export const GET_URGENT_CARE_REPORT = '/report/urgent-care/report'
export const EXPORT_URGENT_CARE_REPORT = '/report/urgent-care/export'

// medical equipment
export const GET_PATIENT_MEDICAL_EQUIPMENT =
  '/patient/:patientUuid/medical-equipment'
export const EXPORT_PATIENT_MEDICAL_EQUIPMENT =
  '/company/patient/:patientUuid/medical-equipment/export'

export const POST_MEDICAL_EQUIPMENT = '/company/medical-equipment'
export const PATCH_DELETE_MEDICAL_EQUIPMENT =
  '/company/medical-equipment/:medicalEquipmentUuid'

// facility management
export const GET_FACILITY_LIST = '/company/facility'
export const EXPORT_FACILITY_LIST = '/company/facility/export'
export const POST_FACILITY = '/company/facility'
export const GET_PATCH_FACILITY = '/company/facility/:facilityUuid'
export const GET_FLOOR_LIST = '/company/floor/facility/:facilityUuid'
export const POST_FLOOR = '/company/floor'
export const GET_PATCH_FLOOR = '/company/floor/:floorUuid'
export const GET_ROOM_LIST = '/company/room/floor/:floorUuid'
export const POST_ROOM = '/company/room'
export const GET_PATCH_ROOM = '/company/room/:roomUuid'
export const PATCH_ROOM_ORDER_NUMBER = '/company/room/updateOrderNumber'

// rpm report
export const GET_OUT_OF_RANGE_RPM_LIST = '/report/rpm-out-of-range/report'
export const EXPORT_OUT_OF_RANGE_RPM = '/report/rpm-out-of-range/export'

// rtm report
export const GET_OUT_OF_RANGE_RTM_LIST = '/report/rtm-out-of-range/report'
export const EXPORT_OUT_OF_RANGE_RTM = '/report/rtm-out-of-range/export'

// rtm dashboard
export const GET_RTM_DASHBOARD = '/workflow/activityLog/rtmDashboard'
export const EXPORT_RTM_DASHBOARD =
  '/workflow/activityLog/exportRtmDashboardSearch'

// ribbon management
export const RIBBON = '/company/admin/ribbon'
export const UPDATE_RIBBON = '/company/admin/ribbon/:uuid'
export const COMPANY_RIBBONS = '/company/ribbon'
export const ACKNOWLEDGE_COMPANY_RIBBON = '/company/ribbon/:uuid/acknowledge'

// referral source
export const REFERRAL_SOURCE_GET_POST = '/company/referralSource'
export const REFERRAL_SOURCE_PATCH_DELETE_ITEM =
  '/company/referralSource/:referralSourceUuid'

// referral payer, legacy, replace with useReferralPayer
export const REFERRAL_PAYER_GET_LIST = '/company/referralPayer'

// provider users
export const PROVIDER_PORTAL_GET_LIST = '/company/providerUser'
export const PROVIDER_PORTAL_POST_ITEM = '/company/providerUser'
export const PROVIDER_PORTAL_GET_PATCH_DELETE_ITEM =
  '/company/providerUser/:providerUserUuid'

// caregiver shift report
export const CAREGIVER_SHIFT_REPORT = '/report/careGiverSchedule/report'
export const EXPORT_CAREGIVER_SHIFT_REPORT =
  '/report/careGiverSchedule/report/export'

export const UNLOCK_CARE_PORTAL_USER = 'auth/user/:userUuid/unlock'
export const UPLOAD_CAREGIVER_SHIFT = '/company/importCareGiverSchedule/:uuid'

// quick message
export const QUICK_MESSAGES_MANAGEMENT_GET_LIST = '/chat/quickMessage'
export const QUICK_MESSAGES_MANAGEMENT_POST_ITEM = '/chat/quickMessage'
export const QUICK_MESSAGES_MANAGEMENT_PATCH_DELETE_ITEM =
  '/chat/quickMessage/:quickMessageUuid'
export const QUICK_MESSAGES_MANAGEMENT_UPDATE_ORDER_NUMBER =
  '/chat/updateQuickMessageOrder'
export const QUICK_MESSAGES_POST_MESSAGE =
  '/chat/chats/:chatUuid/quickMessage/:quickMessageUuid'

// broadcast
export const AGENCY_CASE_MANAGEMENT_GET_LIST = '/company/agencyCaseManager'
export const AGENCY_CASE_MANAGEMENT_POST_ITEM = '/company/agencyCaseManager'
export const AGENCY_CASE_MANAGEMENT_PATCH_DELETE_ITEM =
  '/company/agencyCaseManager/:agencyCaseManagerUuid'

// patient generate phone
export const POST_PATIENT_GENERATE_PHONE =
  '/company/patient/:patientUuid/generatePhone'

// performance dashboard
export const GET_ACTIVITY_COUNTER = '/workflow/activityCounter'

// admin search
export const GET_USER_SERCH = '/company/admin/base-patient'

// urgent care outcome
export const PATCH_URGENT_CARE_OUTCOME =
  '/chat/urgent-care/call/:urgentCareCallUuid/outcome'

// urgent care triage
export const PATCH_URGENT_CARE_TRIAGE =
  '/chat/urgent-care/call/:urgentCareCallUuid/triage'

// urgent care outcome
export const GET_PATIENT_RPM_REPORT_SINGLE =
  '/workflow/measurement/rpm-patient-report/patient/:patientUuid'

// tasks
export const ACTION_HUB_GET_COUNTER = '/company/tasks/assigned'
export const QUICK_CLOSE_TASK = '/company/tasks/bulk/close'

export const COMPANY_ATTACHMENT_POST = '/company/attachment'
export const COMPANY_ATTACHMENT_DELETE_PATCH =
  '/company/attachment/:attachmentUuid'

export const GET_USERS_WITH_ACCESS_TO_PATIENTS = '/company/user'
export const PATCH_TELEMEDICINE_OUTCOME = '/chat/meeting/:meetingUuid/outcome'
export const PATCH_MEETING_TRANSCRIPTION =
  '/chat/meeting/:meetingUuid/transcription'
export const GET_MEETING_DETAILS = '/chat/meeting/:meeting/details'
export const STOP_MEETING_RECORDING = '/chat/meeting/:meeting/stopRecording'
export const STOP_URGENT_CARE_RECORDING =
  '/chat/urgent-care/call/:call/stopRecording'

export const RPM_ANALYSIS_REPORT = '/workflow/measurement/rpm-analysis'
export const RPM_ANALYSIS_GET_EXPORT_REPORT =
  '/workflow/measurement/rpm-analysis/export'

// program report
export const GET_PROGRAM_REPORT_LIST = '/report/program/report'
export const EXPORT_PROGRAM_REPORT_LIST = '/report/program/export'

// rpm report
export const GET_MONITORING_MANAGEMENT_LIST =
  '/workflow/activityLog/monitoringManagementReport'

// patient medical device ordering
export const PATIENT_MEDICAL_DEVICE_ORDERING_POST_ORDER =
  '/company/patient/:patientUuid/order'
export const PATIENT_MEDICAL_DEVICE_ORDERING_PATCH_ORDER =
  '/company/order/:medicalDeviceOrderUuid'
export const PATIENT_MEDICAL_DEVICE_ORDERING_POST_CANCEL =
  '/company/order/:medicalDeviceOrderUuid/cancel'
export const PATIENT_MEDICAL_DEVICE_POST_DISCHARGE_LIVECARE =
  '/company/dischargeLivecarePatient'
export const PATIENT_MEDICAL_DEVICE_GET_LIVECARE_DISCHARGE_HISTORY =
  '/company/dischargeLivecareHistory/patient/:patientUuid'

// actions medical device ordering
export const MEDICAL_DEVICE_ORDERING_GET_LIST = '/company/order'
export const MEDICAL_DEVICE_ORDERING_EXPORT_LIST = '/company/order/export'

// admin medical device ordering
export const ADMIN_MEDICAL_DEVICE_ORDERING_GET_LIST = '/company/admin/orders'
export const ADMIN_MEDICAL_DEVICE_ORDERING_EXPORT_LIST =
  '/company/admin/orders/export'
export const ADMIN_MEDICAL_DEVICE_ORDERING_POST_CANCEL =
  '/company/admin/orders/:medicalDeviceOrderUuid/cancel'
export const ADMIN_MEDICAL_DEVICE_ORDERING_PATCH_ORDER =
  '/company/admin/orders/:medicalDeviceOrderUuid'

// company background
export const POST_COMPANY_BACKGROUND = '/company/admin/company/:uuid/attachment'
export const SAVE_COMPANY_IMAGES = '/company/admin/company/:uuid/images'
export const DELETE_COMAPNY_IMAGE =
  '/company/admin/company/:uuid/images/:companyImageField'

// care team
export const CARE_TEAM_MANAGEMENT_GET_LIST_POST_ITEM = '/company/careTeam'
export const CARE_TEAM_MANAGEMENT_GET_LIST_BY_DIVISION =
  'company/careTeam/:companyDivisionUuid'

// operational dashboard
export const OPERATIONAL_PIVOT = '/company/dashboard/operational/pivot'
export const OPERATIONAL_SUMMARY = '/company/dashboard/operational/summary'

export const EXTERNAL_REFERRAL_ATTACHMENT =
  '/company/patientExternalReferral/:patientExternalReferralUuid/attachment/:attachmentUuid'

export const COMPANY_TELEMEDICINE_ATTACMENT_GET =
  '/company/telemedicineAttachment/facility/:facilityUuid'

export const GET_PCC_ADT_HISTORY =
  '/company/patient/:patientUuid/pcc-adt-history'
export const GET_PCC_ADVANCE_DIRECTIVE_CONSENT =
  'company/patient/:patientUuid/pcc-advance-directive-consent'
